export default "__VITE_ASSET__4f921763__"